import React, { useEffect } from 'react';
import { string, func, bool } from 'prop-types';
import { heapTrackEvent } from '../baui-heap-tracking';

if (!window.widgetFactory) window.widgetFactory = [];
window.widgetFactory.push([
  'login',
  loginSDK => {
    window.currentLoginSDK = loginSDK;
  },
]);

((d, s, id) => {
  if (d.getElementById(id)) return;
  const fjs = d.getElementsByTagName(s)[0];
  const js = d.createElement(s);
  js.id = id;
  js.async = true;
  js.src = `/auth/login-sdk/sdk.${Date.now()}.js`;
  if (fjs) fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'login-jssdk');

const LoginWidget = props => {
  useEffect(() => {
    // componentDidMount
    const loginWidgetConfig = {
      options: {
        container: document.getElementById('login-widget-container'),
        theme: 'lc-baui',
        width: '100%',
        height: '100%',
        loginEmail: props.email,
        firstName: props.firstName,
        loginButtonText: 'Next',
        fadeInOnLoad: true,
        isJoint: props.isJoint,
        forgotPasswordNewWindow: props.forgotPasswordNewWindow,
      },
      onLogin: (err, response) => {
        heapTrackEvent(
          `PL Funnel LoginWidget login ${err ? 'fail' : 'success'}`,
          props.isRepeatsUser ? 'REPEATS' : undefined
        );
        props.onLogin(err, response);
      },
      onRenderWidgetError: loginWidgetIFrame => {
        heapTrackEvent('PL Funnel LoginWidget load fail');
        props.onRenderWidgetError(loginWidgetIFrame);
      },
      onRenderWidgetSuccess: loginWidgetIFrame => {
        heapTrackEvent('PL Funnel LoginWidget load success');
        props.onRenderWidgetSuccess(loginWidgetIFrame);
      },
    };

    window.currentLoginSDK.createWidget(loginWidgetConfig);

    const iframe = document.getElementById('login-widget-iframe');
    iframe.setAttribute('title', 'Login Widget');

    return () => {
      // componentWillUnmount
      window.currentLoginSDK.destructWidget();
      document.getElementById('login-widget-container').removeChild(document.getElementById('login-widget-iframe'));
    };
  }, []);

  return <div id="login-widget-container" />;
};

LoginWidget.propTypes = {
  email: string.isRequired,
  firstName: string.isRequired,
  isRepeatsUser: bool,
  onLogin: func.isRequired,
  onRenderWidgetError: func.isRequired,
  onRenderWidgetSuccess: func.isRequired,
  isJoint: bool.isRequired,
  forgotPasswordNewWindow: bool,
};

LoginWidget.defaultProps = {
  forgotPasswordNewWindow: false,
};

export default LoginWidget;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/rc-login-widget/rc-login-widget.scss');